var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "animate-css",
          rawName: "v-animate-css",
          value: { classes: "fadeInDown", delay: 0, duration: 300 },
          expression: "{ classes: 'fadeInDown', delay: 0, duration: 300 }",
        },
      ],
      staticClass: "settings",
    },
    [
      _c(
        "div",
        {
          staticStyle: {
            display: "flex",
            "flex-direction": "row",
            "justify-content": "end",
          },
        },
        [
          _vm.bar !== 0
            ? _c("a-icon", {
                staticStyle: { "font-size": "23px" },
                attrs: { type: "close" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("close-menu", 0)
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("a-card", { staticStyle: { width: "300px", border: "unset" } }, [
        _c(
          "div",
          {
            staticClass: "m-3 setting-options",
            on: {
              click: function ($event) {
                return _vm.openModal(2)
              },
            },
          },
          [
            _c("span", { staticClass: "mr-2 pr-1" }, [
              _c("span", { staticClass: "material-icons" }, [
                _vm._v(" open_with "),
              ]),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "mt-1 mb-2" }, [
              _vm._v(_vm._s(_vm.$t("chatbotv2.navigation"))),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "m-3 setting-options",
            on: { click: _vm.openActivityLogsModal },
          },
          [
            _c("span", { staticClass: "mr-2 pr-1" }, [
              _c("span", { staticClass: "material-icons" }, [
                _vm._v("history"),
              ]),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "mt-1 mb-2" }, [
              _vm._v("Hareket Loglarını Gör"),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "m-3 setting-options",
            on: { click: _vm.exportDiagramToClipboard },
          },
          [
            _c(
              "span",
              { staticClass: "mr-2 pr-1" },
              [
                _c("a-icon", {
                  staticStyle: { "font-size": "24px" },
                  attrs: { type: "export" },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("p", { staticClass: "mt-1 mb-2" }, [
              _vm._v(_vm._s(_vm.$t("chatbotv2.exportDiagramToClipboard"))),
            ]),
          ]
        ),
        _vm._v(" "),
        _vm.isRoot
          ? _c(
              "div",
              {
                staticClass: "m-3 setting-options",
                on: { click: _vm.openPermissionSettingsModal },
              },
              [
                _c("span", { staticClass: "mr-2 pr-1" }, [
                  _c("span", { staticClass: "material-icons" }, [
                    _vm._v("lock"),
                  ]),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "mt-1 mb-2" }, [
                  _vm._v(_vm._s(_vm.$t("automation.permissions.title"))),
                ]),
              ]
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      [
        _c(
          "div",
          { attrs: { id: "tool-bar-setting-modal" } },
          [
            _c(
              "a-modal",
              {
                attrs: {
                  title: "Settings",
                  wrapClassName: "vertical-center-modal",
                  overlayClassName: "vertical-center-modal",
                  id: "setting-modal",
                  afterClose: function () {
                    _vm.$emit("close-menu", 0)
                  },
                  footer: null,
                  width: "650px",
                },
                model: {
                  value: _vm.modalVisible,
                  callback: function ($$v) {
                    _vm.modalVisible = $$v
                  },
                  expression: "modalVisible",
                },
              },
              [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-xs mx-5" }, [
                    _c(
                      "div",
                      {
                        staticClass: "row chatbot-tool-bar-setting-options",
                        style:
                          _vm.selection === 2
                            ? { fontWeight: "600", color: "#006cff" }
                            : { color: "unset" },
                        on: {
                          click: function ($event) {
                            return _vm.openModal(2)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.$t("chatbotv2.navigation")) +
                            "\n                        "
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-lg col-sm" }, [
                    _vm.selection === 2
                      ? _c("div", { staticClass: "navigation" }, [
                          _c("div", { staticClass: "title" }, [
                            _vm._v(_vm._s(_vm.$t("chatbotv2.navigation"))),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "toolbar-description" }, [
                            _vm._v(
                              "\n                                " +
                                _vm._s(_vm.$t("chatbotv2.navigationDesc")) +
                                "\n                            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex justify-content-center text-center align-items-center pt-3",
                            },
                            [
                              _c(
                                "a-button",
                                {
                                  staticClass: "m-3 p-2",
                                  attrs: {
                                    type: !_vm.navigation ? "primary" : "",
                                    size: "large",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.navigation = false
                                    },
                                  },
                                },
                                [
                                  _c("a-icon", { attrs: { type: "laptop" } }),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("chatbotv2.trackpad"))
                                    ),
                                  ]),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "a-button",
                                {
                                  staticClass: "m-3 p-2",
                                  attrs: {
                                    type: _vm.navigation ? "primary" : "",
                                    size: "large",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.navigation = true
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "md-icon",
                                    {
                                      style: _vm.navigation
                                        ? { color: "white" }
                                        : { color: "" },
                                    },
                                    [
                                      _vm._v(
                                        "mouse\n                                    "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.$t("chatbotv2.mouse"))),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "a-modal",
              {
                attrs: {
                  title: "Hareket Logları",
                  footer: null,
                  width: "800px",
                  afterClose: function () {
                    _vm.$emit("close-menu", 0)
                  },
                },
                model: {
                  value: _vm.activityLogsModalVisible,
                  callback: function ($$v) {
                    _vm.activityLogsModalVisible = $$v
                  },
                  expression: "activityLogsModalVisible",
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "activity-logs-container" },
                  [
                    _vm.loadingActivities
                      ? _c(
                          "a-spin",
                          { attrs: { spinning: _vm.loadingActivities } },
                          [
                            _c("div", {
                              staticStyle: { "min-height": "400px" },
                            }),
                          ]
                        )
                      : [
                          _vm.activities.length === 0
                            ? _c(
                                "div",
                                { staticClass: "empty-state" },
                                [
                                  _c("a-empty", {
                                    attrs: {
                                      description:
                                        "Henüz hareket kaydı bulunmuyor",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _c(
                                "div",
                                { staticClass: "activity-list" },
                                _vm._l(_vm.activities, function (activity) {
                                  return _c("ActivityCard", {
                                    key: activity._id,
                                    attrs: {
                                      activity: activity,
                                      showDate: true,
                                    },
                                  })
                                }),
                                1
                              ),
                        ],
                  ],
                  2
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "a-modal",
              {
                attrs: {
                  title: _vm.$t("automation.permissions.title"),
                  footer: null,
                  width: 1400,
                  afterClose: function () {
                    _vm.$emit("close-menu", 0)
                  },
                },
                model: {
                  value: _vm.permissionSettingsModalVisible,
                  callback: function ($$v) {
                    _vm.permissionSettingsModalVisible = $$v
                  },
                  expression: "permissionSettingsModalVisible",
                },
              },
              [
                _vm.permissionSettingsModalVisible
                  ? _c("AutomationPermissionSettings", {
                      attrs: { automation: _vm.automation },
                      on: {
                        close: _vm.closePermissionSettingsModal,
                        saved: _vm.onPermissionConfigSaved,
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        ),
      ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }